<template>
<svg  xmlns="http://www.w3.org/2000/svg" viewBox="-11.5 780.5 24 24" >
<path d="M0.505,782.5l9.995,9.995l-0.619,0.622L0.505,802.5L-9.5,792.495L0.505,782.5z M0.505,784.977l-7.522,7.519l7.522,7.521
	l7.519-7.521L0.505,784.977z M2.253,788.489c1.543,0.679,2.629,2.222,2.629,4.006c0,2.41-1.97,4.383-4.377,4.383
	c-2.41,0-4.383-1.973-4.383-4.383c0-1.784,1.086-3.324,2.629-4.003v2.053c-0.537,0.48-0.877,1.169-0.877,1.95
	c0,1.463,1.168,2.632,2.632,2.632c1.46,0,2.625-1.169,2.625-2.632c0-0.781-0.341-1.474-0.877-1.95V788.489z M1.379,787.244v5.251
	h-1.754v-5.251H1.379z"/>
</svg>

</template>